






























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import pafCom from './pdf.vue';
import ExtraPreview from './ExtraPreview.vue';
import MediaPreview from './MediaPreview.vue';
import CodePreview from './CodePreview.vue';
@Component({
	name: 'imagePreview',
	components: {
		pafCom,
		ExtraPreview,
		MediaPreview,
		CodePreview,
	},
})
export default class extends Vue {
	@Prop({ default: () => [] }) public list!: any;
	@Prop({ default: () => [] }) public img!: any;
	@Prop({ default: false }) public isHiddenDelBtn!: boolean;
	public visible = true;
	private collapse = true; // 控制左侧显示或隐藏
	private currentPage = 1; // pdf当前页
	private rotate = 0; // pdf旋转交付
	private scrollPage = 0;
	private allPage = 1; // pdf总页数
	private pdfLoading = false;
	private showImg: any = {};
	private officePreviewList = ['doc', 'docs', 'ppt', 'pptx', 'xls', 'xlsx']; // 可以通过office在线预览的后缀列表
	private mediaPreviewList = ['video', 'audio'];
	private codePreviewList = ['json', 'txt', 'md']; // 可以使用编辑器在线预览的类型
	private _dragHandler: any = '';
	private transform = {
		scale: 1,
		deg: 0,
		offsetX: 0,
		offsetY: 0,
		enableTransition: false,
	};
	private loading = false;
	
	
	get imgStyle() {
		const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
		const style = {
			transform: `scale(${scale}) rotate(${deg}deg)`,
			transition: enableTransition ? 'transform .3s' : '',
			marginLeft: `${offsetX}px`,
			marginTop: `${offsetY}px`,
		};
		return style;
	}
	get getScale() {
		return Math.floor(this.transform.scale * 100);
	}
	private close() {
		this.visible = false;
	}
	private created() {
		this.showImg = this.img;
	}
	
	private resetStyle() {
		this.pdfLoading = false;
		this.transform = {
			scale: 1,
			deg: 0,
			offsetX: 0,
			offsetY: 0,
			enableTransition: false,
		};
		this.scrollPage = 0;
		this.currentPage = 1;
		this.rotate = 0;
	}
	private rafThrottle(fn) {
		let locked = false;
		return function (...args) {
			if (locked) {
				return;
			}
			locked = true;
			window.requestAnimationFrame((_) => {
				fn.apply(this, args);
				locked = false;
			});
		};
	}
	
	private handleImgLoad(e) {
		this.loading = false;
	}
	private handleImgError(e) {
		this.loading = false;
		e.target.alt = '加载失败';
	}
	
	
	
	private handleAfterLeave() {
		this.$destroy();
		this.$el.parentNode.removeChild(this.$el);
	}
	
}
